import { Link } from "react-router-dom";
import { servicesData } from "../data/servicesData";

// Map ra 4 dịch vụ nổi bật (hoặc lấy tất cả nếu muốn)
const featuredServices = servicesData.slice(0, 4).map((service, index) => ({
  icon: `0${index + 4}.svg`, // gán icon theo thứ tự
  title: service.title, // lấy trực tiếp title từ data
  slug: service.slug,
  description: service.topSections[1]?.text || "", // lấy text thứ 2 trong topSections
  delay: `.${2 * (index + 1)}s`, // delay 0.2s, 0.4s, 0.6s, 0.8s
}));

const ServiceSection = () => {
  return (
    <section className="service-section fix section-padding">
      <div className="container">
        <div className="section-title-area">
          <div className="section-title">
            <h6 className="wow fadeInUp">Dịch Vụ</h6>
            <h2
              className="wow fadeInUp"
              data-wow-delay=".3s"
            >
              Các Lĩnh Vực <span>Chuyên Môn</span>
            </h2>
          </div>
          <Link
            to="/dich-vu"
            className="theme-btn wow fadeInUp"
            data-wow-delay=".5s"
          >
            Xem thêm
          </Link>
        </div>

        <div className="row g-0">
          {featuredServices.map((service) => (
            <div
              key={service.slug}
              className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={service.delay}
            >
              <div className="service-box-items">
                <div className="icon">
                  <img
                    src={`/assets/img/icon/${service.icon}`}
                    alt={service.title}
                  />
                </div>
                <div className="content">
                  <h3>
                    <Link to={`/dich-vu/${service.slug}`}>{service.title}</Link>
                  </h3>
                  <p>{service.description}</p>
                  <div className="service-btn">
                    <Link
                      to={`/dich-vu/${service.slug}`}
                      className="arrow-icon"
                    >
                      <img
                        src="/assets/img/icon/02.svg"
                        alt="arrow"
                      />
                    </Link>
                    <Link
                      to={`/dich-vu/${service.slug}`}
                      className="link-btn"
                    >
                      Xem chi tiết
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
